<template>
  <div id="embedded-player" ref="embeddedPlayer" :class="type" class="embedded-player">
    <audio id="audioPlayer" ref="audioPlayer">
      <!-- <source src="@/assets/.tmp/test-1.mp3" type="audio/mpeg" > -->
      <!-- <source src="https://dev.muzikair.com:18100/test-1.mp3" type="audio/mpeg" > -->
      <p>Your browser doesn't support HTML5 audio. </p>
    </audio>
    <div v-if="type === 'track'" class="embeded-track-player">
      <div id="player" ref="player" class="player">
        <Transition name="fade">
          <div v-if="currentTrack.id" class="player-wrapper">
            <PlayerProgressBar :play="play" :pause="pause" :set-current-time="setCurrentTime" :duration="duration" :current-time="currentTime" />
            <div class="player-board">
              <div class="control">
                <PlayerPlayBtn :width="playBtnWidth" :height="playBtnHeight" :type="'static'" @click="togglePlay(0)" />
              </div>
              <div class="info">
                <PlayerTrackInfo :track="currentTrack" :translate="false" :embed="true" />
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <!--  -->
    <!--  -->
    <!--  -->
    <div v-if="type === 'playlist'" class="embed-playlist-player">
      <div v-if="playlist" class="playlist">
        <div class="header">
          <TransitionGroup name="fade">
            <div key="cover" class="cover">
              <img :width="playBtnWidth" :height="playBtnHeight"
                   src="@/assets/images/player/icon-playlist.svg" title="playlist" alt="playlist"
              >
            </div>
            <div key="box" class="box">
              <h1 class="title">
                {{ displayLocaleTitle(playlist) }}
              </h1>
              <div class="subtitle">
                <div v-if="playlist.user">
                  {{ $t('PLAYLIST.CREATED_BY', {member: playlist.user.name}) }}
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
        <div ref="cccc" class="content">
          <TransitionGroup name="fade">
            <div v-for="(track, index) in playlist.tracks" :key="track.id" class="track">
              <div class="btn">
                <PlayerPlayBtn :width="playBtnWidth" :height="playBtnHeight" :type="'round'"
                               :in-list="true" :in-list-index="index" :in-list-track-id="track.id" @click="togglePlay(index, track)"
                />
              </div>
              <div class="info">
                <div v-if="track && track.id" class="title">
                  {{ displayComposerName(track.movement.work.people, $i18n.locale) }}
                  <span v-if="track.movement">
                    -
                  </span>
                  {{ displayTrackName(track, $i18n.locale) }}
                </div>
                <div v-if="track" class="subtitle">
                  <span class="performer-list">
                    <span v-for="(performer, pIndex) in filterPerformerList(track.performers)" :key="performer.people_id">
                      {{ displayPerformerName(performer.people, $i18n.locale) }}
                      <span v-if="performer.people && (pIndex < filterPerformerList(track.performers).length - 1)" class="slash">
                        /
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { displayTrackName, displayComposerName, displayPerformerName } from '@/assets/helpers/TrackHelper.js'
import { displayLocaleTitle } from '@/assets/helpers/PlaylistHelper'

import PlayerPlayBtn from '@/components/player/PlayerPlayBtn'
import PlayerTrackInfo from '@/components/player/PlayerTrackInfo'
import PlayerProgressBar from '@/components/player/PlayerProgressBar'

export default {
  name: 'MuzikEmbeddedPlayer',
  components: {
    PlayerProgressBar,
    PlayerPlayBtn,
    PlayerTrackInfo
  },
  filters: {},
  props: {
    type: {
      type: String,
      default: 'TRACK' // TRACK PLAYLIST
    },
    playlist: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      playBtnWidth: window.document.body.clientWidth < 768 ? 40 : 64,
      playBtnHeight: window.document.body.clientWidth < 768 ? 40 : 64
    }
  },
  computed: {
    ...mapState({
      // Namespacing
      clientWidth: state => state.clientWidth,
      initialClick: state => state.player.initialClick,
      display: state => state.player.display,
      displayPanel: state => state.player.panel,
      currentIndex: state => state.player.index,
      currentTrackId: state => state.player.trackId,
      currentTrack: state => state.player.track,
      random: state => state.player.random,
      pool: state => state.player.pool,
      queue: state => state.player.queue,
      paused: state => state.player.paused,
      volume: state => state.player.volume,
      repeat: state => state.player.repeat,
      currentTime: state => state.player.currentTime,
      duration: state => state.player.duration,
      ended: state => state.player.ended
    }),
    ...mapGetters([]),
    rotatePanelIcon() {
      return this.displayPanel ? 'rotated' : ''
    }
  },
  watch: {
    clientWidth(newValue) {
      if (newValue < 768) {
        this.playBtnWidth = 40
        this.playBtnHeight = 40
      } else {
        this.playBtnWidth = 64
        this.playBtnHeight = 64
      }
    },
    paused(newValue) {
      // console.log('Player paused updated', newValue)
      if (!newValue) {
        this.play()
      } else {
        this.pause()
      }
    },
    currentIndex(newValue, oldValue) {
      // console.log(`Player currentIndex updated ${oldValue} => ${newValue}`)
      if (this.queue[newValue].id === this.queue[oldValue].id) {
        // console.log('Same track id, reset current time.')
        this.setCurrentTime(0)
      }
    },
    currentTrackId(newValue, oldValue) {
      // console.log('Player currentTrackId updated', this.displayTrackName(this.currentTrack))
      // console.log(`Player paused ${this.paused}`)
      this.load()
      if (!this.paused) {
        this.play() // load new track and play
      } else {
        // do nothing
      }
    },
    playlist(newValue, oldValue) {
      this.$refs.embeddedPlayer.setAttribute('data-track-nums', newValue.tracks.length)
    }
  },
  created() {},
  updated() {},
  mounted() {
    if (!this.$isMobile) {
      //
    }
    if (this.$refs.audioPlayer) {
      this.$refs.audioPlayer.onloadeddata = this.onLoadedData
      this.$refs.audioPlayer.ontimeupdate = this.onTimeUpdate
      this.$refs.audioPlayer.onended = this.onEnded
      // No use below
      // this.$refs.audioPlayer.oncanplay = () => { console.log('canplay') }
      // this.$refs.audioPlayer.onplay = () => { console.log('onplay') }
      // this.$refs.audioPlayer.onplaying = () => { console.log('onplaying') }
      // this.$refs.audioPlayer.onpause = () => { console.log('onpause') }
      // this.$refs.audioPlayer.onprogress = () => { console.log('onprogress') }
    }
  },
  beforeDestroy() {},
  methods: {
    displayTrackName,
    displayComposerName,
    displayPerformerName,
    displayLocaleTitle,
    filterPerformerList(performerList) {
      let existIdAry = []
      return performerList.filter(performer => {
        if (existIdAry.indexOf(performer.people_id) === -1) {
          existIdAry.push(performer.people_id)
          return performer
        }
        return null
      })
    },
    load() {
      if (this.currentTrack && this.currentTrack['file_link']) {
        // console.log('Player load', this.displayTrackName(this.currentTrack))
        this.$refs.audioPlayer.src = this.currentTrack['file_link']
        this.$refs.audioPlayer.load() // check in onloadeddata
      } else if (this.currentTrack && !this.currentTrack['file_link']) {
        // console.error('No file link in current track...')
      }
    },
    play() {
      // console.log('Player play', this.currentTrack, this.currentTrack.id)
      if (this.currentTrack && this.currentTrack.id) {
        const promise = this.$refs.audioPlayer.play()
        if (promise !== undefined) {
          promise
            .catch(error => {
              console.error(error)
              this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
              // Auto-play was prevented
              // Show a UI element to let the user manually start playback
            })
            .then(() => {
              // play
            })
        }
      } else {
        // console.log('No currentTrack.')
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
      }
    },
    pause() {
      this.$refs.audioPlayer.pause()
    },
    setCurrentTime(newCurrentTime) {
      this.$refs.audioPlayer.currentTime = newCurrentTime
    },
    onLoadedData() {
      this.updatePlayerInfo()
    },
    onTimeUpdate() {
      this.updatePlayerInfo()
    },
    onEnded() {
      // checkQueueEnded
      // console.log('Track ended.')
      if (this.random) {
        this.$store.dispatch('RANDOM_NEXT')
      } else {
        // Normal playing
        if (this.repeat === 2) {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
        } else {
          let nextIndex = this.currentIndex + 1
          if (this.repeat === 1) {
            nextIndex = nextIndex % this.queue.length
          }
          if (nextIndex < this.queue.length) {
            this.$store.commit('SET_PLAYER_INDEX', nextIndex)
          }
          this.$nextTick(() => {
            // console.log('In repeat mode', this.repeat, 'auto continue playing.')
            this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
          })
        }
      }
    },
    updatePlayerInfo() {
      const playerInfo = {
        src: this.$refs.audioPlayer.src,
        currentSrc: this.$refs.audioPlayer.currentSrc,
        autoplay: this.$refs.audioPlayer.autoplay,
        duration: this.$refs.audioPlayer.duration,
        currentTime: this.$refs.audioPlayer.currentTime,
        controls: this.$refs.audioPlayer.controls,
        loop: this.$refs.audioPlayer.loop,
        muted: this.$refs.audioPlayer.muted,
        defaultMuted: this.$refs.audioPlayer.defaultMuted,
        volume: this.$refs.audioPlayer.volume,
        seeking: this.$refs.audioPlayer.seeking,
        paused: this.$refs.audioPlayer.paused,
        ended: this.$refs.audioPlayer.ended
      }
      // console.log('Player Info', playerInfo)
      this.$store.commit('UPDATE_PLAYER_INFO', playerInfo)
    },
    togglePlay(index, track) {
      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      //
      if (this.type.toUpperCase() === 'TRACK') {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', !this.paused)
      } else if (this.type.toUpperCase() === 'PLAYLIST') {
        if (this.currentIndex === index) {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', !this.paused)
        } else {
          // console.log('togglePlay w index setting', index)
          this.$store.commit('SET_PLAYER_INDEX', index)
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.embedded-player.track {
  border-radius: 12px;
  overflow: hidden; // hidden shadow
}
.embedded-player.playlist {
  border-radius: 12px;
  border: solid 2px $theme-yellow;
  overflow: hidden;
}
.embeded-track-player {
  width: calc(100% - 8px);
  margin: 8px 4px;
  .player {
    position: relative;
    height: 96px;
    width: 100%;
    border-radius: 12px;
    box-shadow: 1px 2px 10px 0 rgba(0, 0, 0, 0.27);
    &-board {
      position: absolute;
      bottom: 0;
      height: 90px;
      width: 100%;
      background-color: #ffffff;
      padding: 0 36px;
      border-radius: 0 0 12px 12px;
      border-bottom: solid 1px $grey-ec;
      overflow: hidden;
      .info,
      .control {
        position: relative;
        overflow: hidden;

      }
      .control {
        float: left;
        width: 64px;
        margin-right: 16px;
        margin-top: 13px;
      }
      .info {
        margin-top: 13px;
        // BFC
      }
    }
  }
}
//
.embed-playlist-player {
  // width: calc(100% - 16px);
  // margin: 8px;
  margin-top: 8px;
  width: 100%;
  .playlist {
    .title {
      height: 32px;
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.6;
      color: $grey-50;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .subtitle {
      height: 32px;
      margin: 0;
      font-size: 12px;
      font-weight: 500;
      line-height: 32px;
      color: $grey-7d;

      white-space: nowrap;
      overflow: hidden; // exist by BFC
      text-overflow: ellipsis;
    }
    .header {
      position: relative;
      height: 96px;
      padding: 16px 48px;
      border-bottom: solid 2px $theme-yellow;
      .cover {
        float: left;
        position: relative;
        overflow: hidden;
        width: 64px;
        height: 64px;
        margin-right: 16px;
      }
      .box {
        position: relative;
        overflow: hidden;
      }
    }
    .content {
      .track {
        height: 96px;
        padding: 16px 48px;
        border-bottom: solid 2px $grey-ec;
        &:last-child {
          border-bottom: none;
        }
        .btn {
          float: left;
          position: relative;
          overflow: hidden;
          width: 64px;
          height: 64px;
          margin-right: 16px;
          cursor: pointer;
        }
        .info {
          position: relative;
          overflow: hidden;
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .embeded-track-player {
    width: calc(100% - 8px);
    margin: 20px 4px;
    .player {
      height: 59px;
      &-board {
        height: 59px;
        padding: 0 16px;
        padding-top: 0px; // for embed player
        .control {
          float: left;
          width: 40px;
          margin-right: 8px;
          margin-top: 10px;
        }
        .info {
          margin-top: 0;
        }
      }
    }
  }

  .embed-playlist-player {
    width: calc(100% - 8px);
    margin: 4px;;
    .playlist {
      .title {
        height: 26px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63;
        color: $grey-7d;
      }
      .subtitle {
        height: 18px;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        color: $grey-7d;
      }
      .header {
        height: 59px;
        padding: 0px 16px;
        // padding-top: 9px;
        .cover {
          width: 40px;
          height: 40px;
          margin-right: 8px;
          margin-top: 9px;
        }
        .box {
          padding-top: 7px;
        }
      }
      .content {
        .track {
          height: 59px;
          padding: 0px 16px;
          // padding-top: 9px;
          .btn {
            width: 40px;
            height: 40px;
            margin-right: 8px;
            margin-top: 9px;
          }
          .info {
            padding-top: 7px;
          }
        }
      }
    }
  }
}
</style>
